export const DEFAULT_ITEMS_PER_PAGE = 25;
// Load up to 5 pages at once
export const DEFAULT_PAGES_PRELOAD_COUNT = 5; 
